import styled, { css } from 'styled-components';

import { ProgressRing } from "../Icons/ProgressRing";
import { Button } from "../Buttons/ButtonV2";
import { BtnText, BtnIcon } from "../Buttons/ButtonV2/styles";
import { Card as BasicCard } from "../Card";

const cardPaddingInPx = 16;

export const Card = /*#__PURE__*/styled(BasicCard).withConfig({ displayName: "styles__Card", componentId: "sc-18tejvb-0" })(["padding:", "px;position:relative;overflow:hidden;box-sizing:content-box;transition-duration:300ms;margin-bottom:", ";", " ", ";&.dismissing-card-exit{opacity:1;}&.dismissing-card-exit-active,&.dismissing-card-exit-done{opacity:0;}"],




cardPaddingInPx,




({ theme }) => theme.spacers.M,

({ height, theme, backgroundColor }) => css(["height:", ";background-color:", ";"],
height ? `${height}px` : 'auto',
backgroundColor ?? theme.colors.ElementBackground),


(props) =>
props.dismissed ?
css(["border-color:transparent;background-color:", ";"],

props.theme.colors['Level 1']) :

'');











export const Content = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Content", componentId: "sc-18tejvb-1" })([""]);

export const DismissingContainer = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__DismissingContainer", componentId: "sc-18tejvb-2" })(["", ";"],
(props) =>
props.hasTimeout ?
css(["display:flex;align-items:center;"]) :



'');


export const DismissedText = /*#__PURE__*/styled.p.withConfig({ displayName: "styles__DismissedText", componentId: "sc-18tejvb-3" })(["flex:1 1 auto;align-self:flex-start;color:", ";", ";line-height:32px;"],


(props) =>
props.hasTimeout ? props.theme.colors['Level 4'] : props.theme.colors['Level 5'],
(props) => css(props.theme.typography.Paragraph));



export const UndoButton = /*#__PURE__*/styled(Button).withConfig({ displayName: "styles__UndoButton", componentId: "sc-18tejvb-4" })(["display:flex;align-items:center;justify-content:center;margin-right:8px;", "{line-height:24px;color:", ";", ";}", "{max-width:unset;}"],






BtnText,

(props) => props.theme.colors['Level 5'],
(props) => css(props.theme.typography.Paragraph),


BtnIcon);




export const CircleDismissButton = /*#__PURE__*/styled(Button).withConfig({ displayName: "styles__CircleDismissButton", componentId: "sc-18tejvb-5" })(["width:24px;height:24px;border:none;border-radius:12px;padding:0;min-width:auto;display:flex;align-items:center;justify-content:center;position:absolute;", ""],















(props) => css(["top:", "px;right:", "px;"],
props.$position?.top ?? cardPaddingInPx,
props.$position?.right ?? cardPaddingInPx));



export const TimerDismissButton = /*#__PURE__*/styled(Button).withConfig({ displayName: "styles__TimerDismissButton", componentId: "sc-18tejvb-6" })(["width:32px;height:32px;border:0;padding:0;", "{max-width:unset;margin:0;}"],





BtnIcon);





export const TimerProgress = /*#__PURE__*/styled(ProgressRing).withConfig({ displayName: "styles__TimerProgress", componentId: "sc-18tejvb-7" })(["position:absolute;top:0;left:0;z-index:2;"]);






export const ButtonsWrap = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__ButtonsWrap", componentId: "sc-18tejvb-8" })(["display:flex;margin-top:", ";"],

({ theme }) => theme.spacers.XL);


export const ConfirmCancelButton = /*#__PURE__*/styled(Button).withConfig({ displayName: "styles__ConfirmCancelButton", componentId: "sc-18tejvb-9" })(["display:flex;align-items:center;justify-content:center;margin-right:8px;", "{line-height:24px;color:", ";", ";}", "{max-width:unset;}"],






BtnText,

({ theme }) => theme.colors.negative,
(props) => css(props.theme.typography.Paragraph),


BtnIcon);